<template lang="pug">
   Modal(ref="dlg" title="Check Code" closeable="true")
    .check-code-modal.ssp-form-horizontal
      .row
        label.col-sm-4 Code Index
        .col-sm-8
          input.form-control.focus(type="number" @input="onCodeIndexInput($event.target.value)")
      .row(v-if="code")
        .form-group.center
          VueQrcode(:value="code" :options="{level: 'L', size: 150}")
      .row(v-if="code")
        label.col-sm-4 Code Content
        .col-sm-8
          input.form-control(v-model="code")
      .form-group.pt20(v-if="definedCode")
        p.text-info The code with index {{codeIndex}} is undefined

    div(slot="footer")
      button.btn.btn-primary(@click="close()") Close

</template>

<script>
import debounce from 'debounce'
import VueQrcode from '@xkeshi/vue-qrcode'
import Modal from '@/components/common/Modal'
import Core from '@/service/apis/Core'

export default {
  props: {
    orderId: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    codeIndex: null,
    code: null
  }),
  created() {
    this.onCodeIndexInput = debounce(this.onCodeIndexInput, 200);
  },
  methods: {
    onCodeIndexInput(codeIndex) {
      this.codeIndex = codeIndex
      this.getCode(codeIndex)
    },
    getCode(codeIndex) {
      Core.findCode(this.orderId, codeIndex)
        .then((resp) => {
          this.code = resp
          this.errorMsg = null
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    open() {
      this.$refs.dlg.open()
    },
    close() {
      this.$refs.dlg.cancel()
    }
  },
  computed: {
    definedCode() {
      if (typeof this.code !== 'undefined') {
        return false
      }
      return true
    }
  },
  components: {
    Modal,
    VueQrcode
  }
}
</script>

<style lang="scss">
.check-code-modal {
  min-width: 350px;
  .center {
    padding: 20px;
    margin: auto;
    width: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/order/code/CheckCodeModal.vue